module.exports = __webpack_public_path__ + "img/sparks-03.5f94501c.png";